module.exports = __webpack_public_path__ + "static/media/how-we-work1.22445f82.svg";